import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { Router } from '@angular/router';
import { ApiservicesService } from '../../../Services/Apis/apiservices.service';
import { ActivatedRoute } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { EcontentServicesService } from '../../../inputfileds/form_services/econtent-services/econtent-services.service';
import { TranslateDirective } from '../../../components/Utilites/Directives/translate.directive';

@Component({
    selector: 'app-econtent-semisters',
    imports: [
        MatIconModule,
        MatExpansionModule,
        MatListModule,
        CommonModule,
        ReactiveFormsModule,
        MatButtonModule,
        TranslateDirective
    ],
    templateUrl: './econtent-semisters.component.html',
    styleUrl: './econtent-semisters.component.scss'
})
export class EcontentSemistersComponent implements OnInit {
  semesters: { semister_id: number; Semester_Number: string }[] = [];
  selectedSemester: number | null = null;

  subjectsList: string[] = [];
  coursesId!: number;
  subjectsId: number[] = [];

  subjectsCode: number[] = []

  constructor(
    private router: Router,
    private apiservices: ApiservicesService,
    private route: ActivatedRoute,
    private eContentFormQuestions: EcontentServicesService
  ) {
    this.eContentFormQuestions.getecontentform();
  }

  ngOnInit(): void {
    this.coursesId = +this.route.snapshot?.params['courseId'];
    this.getEcontentSemisterData();
  }

  getEcontentSemisterData() {
    this.apiservices.getEcontentSemisterList(this.coursesId).subscribe({
      next: (res: any) => {
        if (res?.data.length) {
          this.semesters = res.data.map((item: any) => item);
          const firstSemester = this.semesters[0];
          this.selectSemester(firstSemester.semister_id);
        } else {
          console.error('No semesters found.');
        }
      },
      error: (err) => {
        console.error('Failed to fetch semesters:', err);
      },
    });
  }

  getEcontentSubjectData(semester: number) {
    this.apiservices
      .getEcontentSubjectList(this.coursesId, semester)
      .subscribe({
        next: (res: any) => {
          const subjects = res.data.map((item: any) => item.Subject);
          const subjectsId = res.data.map((item: any) => item.subject_id);
          const subjectsCode = res.data.map((item: any) => item.subject_code);
          this.subjectsList = subjects;
          this.subjectsCode = subjectsCode;
          this.subjectsId = subjectsId;
        },
        error: (err) => {
          console.error('Failed to fetch subjects:', err);
        },
      });
  }

  selectSemester(semesterId: number) {
    this.selectedSemester = semesterId;
    this.getEcontentSubjectData(semesterId);
  }

  viewESubjectData(subjectId: number,subjectname:any) {
    this.router.navigate([
      `e-content/${this.coursesId}/${this.selectedSemester}/${subjectId}/${subjectname}/econtent-subjects-data`,
    ]);
  }

  navigateToBackPage() {
    window.history.back();
  }

  addEcontent(){
    this.eContentFormQuestions.setshowform(true);
    this.eContentFormQuestions.setformcls({});
    window.history.back();
  }

}
